import {Component, Inject, OnInit, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSidenavContainer} from '@angular/material/sidenav';
import {KeycloakService} from 'keycloak-angular';
import {Role} from '../../../clm/types/role.enum';
import {BasicPersonDetailDTO} from '../../../ent/models/person/BasicPersonDetailDTO';
import {EnvironmentService} from '../../services/environment-service';
import {DisplayStrings} from '../../constants/DisplayStrings';
import {UserAuthorisationService} from '../../services/user-authorisation.service';

enum Tabs {
  MemberOverview,
  PolicyOverview,
  Documents,
  VivaScoreOverview,
  HomeAffairsPersonProfile,
  Cases,
  Transactions,
  Contributions,
  Utilisation,
  Payments,
  SMS,
  Email
}

@Component({
  selector: 'app-member-overview-dialog',
  templateUrl: './member-overview-dialog.component.html',
  styleUrls: [
    '../../../../../styles/global/_dialog-styles.scss',
    './member-overview-dialog.component.scss']
})
export class MemberOverviewDialogComponent implements OnInit {
  readonly Tabs = Tabs;
  readonly DisplayStrings = DisplayStrings.memberOverviewDialogPermissionsErrorMessages;
  readonly PolicyHolderGroupIdForAffinityStaff = 1;
  readonly availableTabs = [
    { name: 'Person Overview', value: Tabs.MemberOverview},
    { name: 'Membership Overview', value: Tabs.PolicyOverview},
    { name: 'Documents', value: Tabs.Documents},
    { name: 'VivaScore Overview', value: Tabs.VivaScoreOverview},
    { name: 'Dpt of Home Affairs Person Profile', value: Tabs.HomeAffairsPersonProfile},
    { name: 'Cases', value: Tabs.Cases},
    { name: 'Transactions', value: Tabs.Transactions},
    { name: 'Contributions', value: Tabs.Contributions},
    { name: 'Utilisation', value: Tabs.Utilisation},
    { name: 'Payments', value: Tabs.Payments},
    { name: 'SMSes', value: Tabs.SMS},
    { name: 'Emails', value: Tabs.Email}
  ];

  isAllowHealthCloudScore: boolean;
  isAllowedGovernmentData: boolean;
  hasOnboardingRole = false;

  activeTabIndex = 0;
  selectedTab = Tabs.MemberOverview;
  keycloakRoles: string[];
  policyID: number;
  policyHolderGroupID: number;
  policyNumber: string;


  constructor(public dialogRef: MatDialogRef<MemberOverviewDialogComponent>,
              private keycloakService: KeycloakService,
              private environmentService: EnvironmentService,
              private userAuthorisationService: UserAuthorisationService,
              @Inject(MAT_DIALOG_DATA) public basicPersonDetail: BasicPersonDetailDTO) {
  }

  ngOnInit(): void {
    this.keycloakRoles = this.keycloakService.getUserRoles();
    this.hasOnboardingRole = this.doesUserHaveCommunicationPermissions();
    this.isAllowHealthCloudScore = this.environmentService.isAllowHealthCloudScore();
    this.isAllowedGovernmentData = this.environmentService.isAllowedToViewGovernmentData();

    this.onSetPolicyId(this.basicPersonDetail.policyId)
    this.onSetPolicyNumber(this.basicPersonDetail.policyNumber)
    this.onSetPolicyholderGroupId(this.basicPersonDetail.policyHoliderGroupId)
  }

  canView(): boolean {
    return (
      // Case: PHG id !=1 aka (Affinity Staff) anyone can view the data no matter the role
      this.policyHolderGroupID !== this.PolicyHolderGroupIdForAffinityStaff ||
      // Case: PHG id matches 1 aka (Affinity Staff) then role at least one of following role must exist in loggedIn user
      this.policyHolderGroupID === this.PolicyHolderGroupIdForAffinityStaff && this.checkCertainRolesCanViewData()
    );
  }

  onSetPolicyholderGroupId(policyHolderGroupID: number): void {
    this.policyHolderGroupID = policyHolderGroupID;
  }

  onSetPolicyId(policyId: number): void {
    this.policyID = policyId;
  }

  onSetPolicyNumber(policyNumber: string): void {
    this.policyNumber = policyNumber?.trim();
  }

  private checkCertainRolesCanViewData(): boolean {
    return this.multipleInArray(this.keycloakRoles, [Role.ClaimsTeamLeader, Role.PreAuthorisationTeamLeader]);
  }

  private multipleInArray(keycloakRoles: string[], rolesToMatch: string[]): boolean {
    return rolesToMatch.some(value => {
      return keycloakRoles.includes(value);
    });
  }

  private doesUserHaveCommunicationPermissions(): boolean {
    return this.userAuthorisationService.hasRoleEnterpriseManager() || this.userAuthorisationService.hasOnBoardingTeamLeader();
  }

}
